import { Pipe, PipeTransform } from '@angular/core';
import { Decimal } from 'decimal.js';

@Pipe({
  name: 'decimal',
  standalone: true,
})
export class DecimalPipe implements PipeTransform {
  transform(val1: number, val2: number, operation: string) {
    switch (operation) {
      case 'min': {
        return new Decimal(val1).minus(val2).toNumber();
      }
      case 'plus': {
        return new Decimal(val1).plus(val2).toNumber();
      }
      case 'div': {
        return new Decimal(val1).div(val2).toNumber();
      }
      case 'mul': {
        return new Decimal(val1).mul(val2).toNumber();
      }
      default: {
        throw new Error(`Invalid operation: ${operation}`);
      }
    }
  }
}
